/* eslint-disable */
import axios from "axios";
import managePatientModal from "../managePatientModal/managePatientModal.vue";
import manageVisitModal from "../manageVisitModal/manageVisitModal.vue";
import manageSoAModal from "../ManageSoAModal/ManageSoAModal.vue";
import store from "../../store/index";
import moment from "moment";
import VPagination from "@hennge/vue3-pagination";
import CreateSitePopUp from "../CreateSitePopUp/CreateSitePopUp.vue";
import EditStudyPopUp from "../EditStudyPopUp/EditStudyPopUp.vue";
import createnewversion from "../newversion/createnewversion.vue";
import retireFormPopUp from "../retireFormPopUp/retireFormPopUp.vue";
import importForms from "../importForms/importForms.vue";
import Forms_AI_PopUp from "../Forms_AI_PopUp/Forms_AI_PopUp.vue";
import Multiselect from "@vueform/multiselect";
import importstudymodel from "./importstudymodel.vue";
import uploadstudyprotocol from "./uploadstudyprotocol.vue";
// import {
//   startNotificationConnection,
//   stopNotificationConnection,
//   onNotificationReceived
// } from "@/services/notificationService";

export default {
  name: "studyProfile",
  components: {
    VPagination,
    managePatientModal,
    manageVisitModal,
    manageSoAModal,
    CreateSitePopUp,
    EditStudyPopUp,
    createnewversion,
    retireFormPopUp,
    Multiselect,
    importForms,
    Forms_AI_PopUp,
    importstudymodel,
    uploadstudyprotocol
  },
  data() {
    return {
      baseurl: process.env.VUE_APP_Service_URL,
      uploadstudyprotocolpopup: false,
      importstudymodal:false,
      showSiteModal: false,
      showPatientModal: false,
      showFormsModal: false,
      token: store.getters.getIdToken,
      head: "",
      // -- pagination -- 
      currentTemplatePage: 1,
      templatePageSize: 10,
      totalTemplatePages: 1,
      currentVisitPage: 1,
      visitPageSize: 10,
      totalVisitPages: 1,
      currentSitesPage: 1,
      sitesPageSize: 10,
      totalSitesPages: 1,
      currentSubjectPage: 1,
      subjectPageSize: 10,
      totalSubjectPages: 1,
      currentRecentFormsPage:1,
      currentRecentFormsSize:10,
      totalRecentFormsPage:1,
      totalVisitPages: 1,
      currentVisitiPages: 1,
      soaTotalPages: 1,
      soaCurrentPage: 1,

      showSidePopup: [false],
      showVisitPopup: [false],
      showSoaPopup: [false],
      studyDetails: "",
      studyTemplates: [],
      defaultdate: "",
      visitList: [],
      returnList:[],
      patientLists:[],
      studyId: "",
      visitId: "",
      siteModal: false,
      showAssignTemplate: false,
      studyEditModal: false,
      newtemplate: "",
      creatversionpopup: false,
      newversionformid: "",
      templatelist: [],
      permissiontemplatlist:[],
      selectedTemplateIds: [],
      selectedvisitid: "",
      sourceId: "",
      sourceVersion: "",
      retireFormModal: false,
      rollsprivilages: "",
      AIpopup: false,
      formItems: [],
      templates:[],
      values: {
        modelName: "StudyDIsName",
        description: "",
        threshold: 0.7
      },
      showLoadingAnimation: false,
      clicked: false,
      showVisitForms: false,
      formsArray: [],
      SoAList: [],
      activityType: "",
      selectedStudy:"",
      showSoAModal: false,
      loadingECRFtemplates:false,
      loadingVisitList:false,
      loadingSiteList:false,
      showPatientLoading:false,
      currentVisitiPages: 1,
      soAId: "",
      addPrivilegeModal: false,
      addPrivilegebutton: true,
      showRecentFormsLoading:false,
      roleList: [],
      formlists:[],
      selectedTemplateId: [],
      selectedRoleList: [],
      rolesAndPrivilegelist:{},
      temprolesAndPrivilegelist:{},
      selectedPrivilegeList: [],
      privilegeList: [
        { value: "Add", label: "Add" },
        { value: "View", label: "View" },
        { value: "Edit", label: "Edit" },
      ],
      notifications: [],
      steps :[
            { value: 1, label: 'Import Study' },
            { value: 2, label: 'Generate Site' },
            { value: 3, label: 'Generate Subject' },
            { value: 4, label: 'Generate eCRF Data' }
          ],
      currentStep :0,
      showNotifPopup: false,
      studyImported:false,
      setSiteImport:false,
      setSubjectImport:false,
      setSyntheticData:false,
      setSyntheticDataImport:false,
      loadingSiteImport:false,
      loadingSubjectImport:false,
      loadingSyntheticData:false
    };
    
  },

  async mounted() {
    this.defaultdate = localStorage.getItem("dateformat");
    // await startNotificationConnection();
    this.token=store.getters.getIdToken
    // onNotificationReceived((payload) => {
    //   console.log("New notification in component:", payload);
    //   this.notifications.unshift(payload);
    //   this.showNotifPopup = true;
    // });    
    this.head = {
      headers: {
        Authorization: "Bearer " + this.token,
        "Content-Type": "application/json",
      },
    },
    this.defaultdate = localStorage.getItem("dateformat");
    this.rollsprivilages = await store.getters.getRolesprivilegeData;
    window.addEventListener("studyIdChanged", async (event) => {
      this.studyId = store.getters.getStudyIs
      await this.getStudyDetails();
    });
    this.studyId = store.getters.getStudyIs
    if (this.studyId == null || this.studyId == "") {
      alert(this.$t('navigations.no study selected'))
    }
 document.addEventListener("click", this.onDocumentClick);
  },
  async beforeUnmount() {
    // await stopNotificationConnection();
     document.removeEventListener("click", this.onDocumentClick);
  },
  computed: {
    privilegeRows() {
      return this.selectedRoleList.flatMap(roleId =>
        this.selectedTemplateIds.map(templateId => {
          const tmpl = this.templates.find(t => t.templateId === templateId) || {};
          return {
            roleId,
            templateId,
            roleName: this.fetchRoleName(roleId),
            templateName: tmpl.templateName
          };
        })
      );
    },
    selectedmodeltemplate() {
      return this.selectedTemplateIds.map(id => {
        return this.templatelist.find(template => template.templateId === id);
      });
    }
  },
  methods: {
    routeBack(importType){
      switch (importType) {
        case 'fromSite':
          this.studyImported=false
          this.setSiteImport=false
          this.currentStep--
          break;
        case 'fromSubject':
          this.setSiteImport=true
          this.setSubjectImport=false
            this.currentStep--
          break;
        case 'fromSyntheticData':
          this.setSubjectImport=true
          this.setSyntheticData=false
            this.currentStep--
          break;
        default:
            console.warn("Invalid import type:", screen);
            break;
      }
    },
    async setStudy(value){
      if(value){
        this.studyImported=true
        this.initialStudyLoader=true      
        this.selectedStudy=value
        this.setSiteImport=true   
        this.currentStep++      
        await this.getECRF(value)
        await this.getVisits(value)
        await this.getSites(value)
        await this.getSubjects(value)
        await this.getRecentForms(value)
        await this.importSite()
       
        this.initialStudyLoader=false       
      }
    },
    async importSite(){
      this.loadingSiteImport=true
      axios.post(`${this.baseurl}/management/study/syntheticsite?StudyId=${this.selectedStudy}`, 
        {},
        this.head
      )
        .then((res) => {
              this.loadingSiteImport=false
              // alert(this.$t("navigations.site imported successfully"))
              this.currentStep++
              // this.setSiteImport=false
              // this.setSubjectImport=true
             
              if(res.data=='Sites Created'){
                this.importSubject()
                 this.getSites(store.getters.getStudyIs)
              }
               
        })
        .catch(err => {
          console.log("error in get study", err)
          this.loadingSiteImport=false
        });
    },
    async importSubject(){
      this.loadingSubjectImport=true
      axios.post(`${this.baseurl}/management/study/syntheticsubjects?StudyId=${this.selectedStudy}`, 
               {},
        this.head
      )
        .then((res) => {
              this.loadingSubjectImport=false       
              // this.setSubjectImport=false
              // this.setSyntheticData=true
              this.currentStep++           
              if(res.data=='Subjects Created'){
                this.importSyntheticData()
                this.getSubjects(store.getters.getStudyIs)
              }
          })
        .catch(err => {
          console.log("error in get study", err)
          this.loadingSubjectImport=false
        });
    },
    async importSyntheticData(){
      this.loadingSyntheticData=true
      axios.post(`${this.baseurl}/management/study/syntheticforms?StudyId=${this.selectedStudy}`, 
               {},
        this.head
      )
        .then((res) => {
              this.loadingSyntheticData=false
              // alert(this.$t("navigations.eCRF data imported successfully"))
              this.currentStep++    
              this.getRecentForms(store.getters.getStudyIs)
              
          })
        .catch(err => {
          console.log("error in get study", err.response.data)
          if(err && err.response && err.response.data && err.response.data.errors  && err.response.data.errors.DomainValidations){
            alert(err.response.data.errors.DomainValidations[0])
          }
          this.loadingSyntheticData=false
        });
    },
    async getECRF(value) {
      this.loadingECRFtemplates=true
      axios.get(`${this.baseurl}/forms/template/listtemplate?IsPrivileged=false&Status=Approved&StudyID=${value}&pageindex=${this.currentTemplatePage}&pagesize=${this.templatePageSize}&SortProperty=templateName&SortOrder=0`, 
        this.head
      )
        .then((res) => {
          this.loadingECRFtemplates=false
          this.studyTemplates = res.data.results;

          let totalCount = res.data.totalCount;
          this.totalTemplatePages = parseInt(totalCount / this.templatePageSize);
          if (totalCount % this.templatePageSize != 0) {
            this.totalTemplatePages = this.totalTemplatePages + 1;
          }
        })
        .catch(err => {
          console.log("error in get study", err)
          this.initialStudyLoader=false  
          this.loadingECRFtemplates=false
        });
    },
    async getVisits(value) {
      this.loadingVisitList=true
      axios.get(`${this.baseurl}/management/visit/listvisit?StudyId=${value}&pageindex=${this.currentVisitiPages}&pagesize=${this.visitPageSize}&SortProperty=visitNo&ConvertToNumeric=true&SortOrder=0`, this.head)
        .then((res) => {
          this.loadingVisitList=false
          this.visitList = res.data.results;
          let totalCount = res.data.totalCount;
          this.totalVisitPages = parseInt(totalCount / this.visitPageSize);
          if (totalCount % this.visitPageSize != 0) {
            this.totalVisitPages = this.totalVisitPages + 1;
          }
        })
        .catch(err => {
           this.loadingVisitList=false
          console.log("error in list visit", err)
          }
        );
    },
    async getSites(value) {
      this.loadingSiteList=true
      await axios
        .get(
          `${this.baseurl}/management/site/searchlist?StudyID=${value}&pageindex=${this.currentSitesPage}&pagesize=${this.sitesPageSize}`,
          this.head
        )
        .then((res) => {
          this.loadingSiteList=false
          this.returnList = res.data.results;
          this.siteCode = this.returnList.siteCode;
          let totalCount = res.data.totalCount;
          this.totalSitesPages = parseInt(totalCount / this.sitesPageSize);
          if (totalCount % this.sitesPageSize != 0) {
            this.totalSitesPages = this.totalSitesPages + 1;
          }
        })
        .catch((err) => {
          console.log(err);
          this.loadingSiteList=false
        });
    },
    async getRecentForms(value) {
      this.showRecentFormsLoading = true
       await axios
        .get(`${this.baseurl}/forms/forms/getpaginatedrecentforms?studyId=${value}&pageindex=${this.currentRecentFormsPage}&pagesize=${this.currentRecentFormsSize}`, 
          this.head
        )
        .then((response) => {
          this.showRecentFormsLoading=false
          this.currentStep++
          if (response.data) {
            this.formlists = response.data.results;      
             let totalCount = response.data.totalCount;
            this.totalRecentFormsPage = parseInt(totalCount / this.currentRecentFormsSize);
            if (totalCount % this.currentRecentFormsSize != 0) {
              this.totalRecentFormsPage = this.totalRecentFormsPage + 1;
            }     
          } else {
            console.log("no forms found");
          }
        })
        .catch((err) => {
          console.log(err);
          this.showRecentFormsLoading=false
        });
    },
      async getSubjects(value) {
      this.showPatientLoading = true
      await axios
        .get(
          `${this.baseurl}/management/patient/listpatient?Studyid=${value}&pageindex=${this.currentSubjectPage}&pagesize=${this.subjectPageSize}`,
          this.head
        )
        .then((res) => {
          this.patientLists = res.data.results;
          this.totalSubjectPages = parseInt(res.data.totalCount / this.subjectPageSize);
           let totalCount = res.data.totalCount;
           if (totalCount % this.subjectPageSize != 0) {
            this.totalSubjectPages = this.totalSubjectPages + 1;
          }
          
          this.showPatientLoading = false;
        })
        .catch((err) => {
          console.error("No data found");
          this.showPatientLoading = false;
        });
    },
    loadTemplate: function (page) {
      this.currentTemplatePage = page;
      this.getECRF(this.selectedStudy);
    },
    loadVisit: function (page) {
      this.currentVisitiPages = page;
      this.getVisits(this.selectedStudy);
    },
    loadSites: function (page) {
      this.currentSitesPage = page;
      this.getSites(this.selectedStudy);
    },
    loadPatients: function (page) {
      this.currentSubjectPage = page;
      this.getSubjects(this.selectedStudy);
    },
     loadRecentPages: function (page) {
      this.currentRecentFormsPage = page;
      this.getRecentForms(this.selectedStudy);
    },
    filter(data) {
      if (data) {
        return moment(data).format(this.defaultdate);
      }
    },
    clearnotification(){
      this.notifications = [];
    },
    onDocumentClick(event) {
      if (!this.showNotifPopup) return;
      const popupEl = this.$refs.popup;
      const bellEl = this.$refs.bellIcon;

      if (!popupEl || !bellEl) {
        this.showNotifPopup = false;
        return;
      }

      if (
        !popupEl.contains(event.target) &&
        !bellEl.contains(event.target)
      ) {
        this.showNotifPopup = false;
      }
    },
    toggleNotificationPopup() {
    this.showNotifPopup = !this.showNotifPopup;
  },
     formatNotification(payload) {
      if (payload.message) {
        return payload.message + (payload.priority ? ` (priority: ${payload.priority})` : "");
      }
      return JSON.stringify(payload);
    },
    closeprotocolpopup(){
        this.uploadstudyprotocolpopup=false;
    },
    openUploadModal(){
        this.uploadstudyprotocolpopup=true;
    },
    closeimportstudy(){
        this.importstudymodal = false;
    },
    openimportstudymodal(){
        this.importstudymodal = true;
    },
    onRoleChange(newRoles) {
    // 1) update selectedRoleList
    this.selectedRoleList = newRoles;

    // 2) for each newly-added role, ensure a map and empty arrays exist
    newRoles.forEach(rid => {
      if (!this.rolesAndPrivilegelist[rid]) {
        // create the template-map object
        this.rolesAndPrivilegelist[rid] = {};
      }
      this.selectedTemplateIds.forEach(tid => {
        if (!Array.isArray(this.rolesAndPrivilegelist[rid][tid])) {
          this.rolesAndPrivilegelist[rid][tid] = [];
        }
      });
    });

    // (we’re intentionally not deleting old rid keys so that re-selecting preserves previous choices)
    },

    onTemplateChange(newTemps) {
      // 1) update selectedTemplateIds
      this.selectedTemplateIds = newTemps;

      // 2) for each newly-added template, ensure every selected role has an array
      newTemps.forEach(tid => {
        this.selectedRoleList.forEach(rid => {
          const roleMap = this.rolesAndPrivilegelist[rid] || (this.rolesAndPrivilegelist[rid] = {});
          if (!Array.isArray(roleMap[tid])) {
            roleMap[tid] = [];
          }
        });
      });

      // (again, don’t remove old tid keys)
    },
    fetchRoleName(roleID) {
      const role = this.roleList.find(r => r.roleID === roleID)
      return role
        ? role.roleName
        : ''      // or return a default/fallback
    },
    // study data excel automation Starts
    filterDate(date) {
      if (date) {
        return moment(date).format(this.defaultdate);
      }
    },
 
    async privilegeform() {
      // reset everything
      this.selectedRoleList   = [];
      this.selectedTemplateIds = [];
      this.rolesAndPrivilegelist = {};
    
      // ensure we have the up-to-date list of roles
      await this.getRoleList();
    
      // now fetch privileges (no roleId filter)
      await this.getFormPrivilege();
    
      // only now display the popup
      this.addPrivilegeModal = true;
    },
    closePrivilege(){
      this.addPrivilegeModal = false;
      this.selectedRoleList = [];
      this.selectedTemplateIds = [];
      this.rolesAndPrivilegelist = {};
    },
    openretireModal(id, versionNo) {
      this.retireFormModal = true
      this.sourceId = id
      this.sourceVersion = versionNo
    },
    async getStudyDetails() {
      axios.get(`${this.baseurl}/management/study/getbyid?id=${this.studyId}`, this.head)
        .then((res) => {
          this.studyDetails = res.data;
        })
        .catch(err => console.log("error in get study", err));
    },
    async getRoleList() {
      axios.get(`${this.baseurl}/account-core/roles/rolelist`, this.head)
        .then((res) => {
          console.log("Role details ", res.data);
          this.roleList = res.data;

        })
        .catch(err => console.log("error in get study", err));
    },
    isAllSelected(col) {
      return this.privilegeRows.every(row => {
        const arr = this.rolesAndPrivilegelist[row.roleId][row.templateId] || [];
        return arr.includes(col);
      });
    },
    toggleColumn(col, event) {
      const checked = event.target.checked;
      this.privilegeRows.forEach(row => {
        const arr = this.rolesAndPrivilegelist[row.roleId][row.templateId];
        if (checked) {
          // add if missing
          if (!arr.includes(col)) {
            arr.push(col);
          }
        } else {
          // remove all instances
          const idx = arr.indexOf(col);
          if (idx !== -1) {
            arr.splice(idx, 1);
          }
        }
      });
      // force Vue to see the change (if needed)
      this.rolesAndPrivilegelist = { ...this.rolesAndPrivilegelist };
    },
    async createFormPrivilege() {
      // 1) validation
      if (this.selectedRoleList.length === 0) {
        alert(this.$t("navigations.please select role and privilege"));
        return;
      }
      if (this.selectedTemplateIds.length === 0) {
        alert(this.$t("navigations.no template selected"));
        return;
      }
  
      // 2) build payload
      const payload = this.formatPrivileges(
        this.rolesAndPrivilegelist,
        this.selectedTemplateIds
      );
  
      // 3) send
      try {
        const res = await axios.post(
          `${this.baseurl}/forms/formsprivilege/createprivilege`,
          payload,
          this.head
        );
        console.log("Privilege created", res.data);
        alert(this.$t("navigations.privilege created successfully"));
  
        // 4) reset modal
      } catch (err) {
        console.error("error in creating privilege", err);
        alert(this.$t("navigations.failed to create privilege"));
      }
    },
    formatPrivileges(rolesAndPrivilegelist, templateIds) {
      // rolesAndPrivilegelist: { [roleId]: { [templateId]: ["Add","View",…] } }
      const rolePrivileges = Object.entries(rolesAndPrivilegelist).map(
        ([roleId, templatesMap]) => {
          // build one permission block per template
          const permission = templateIds.map(templateId => {
            const tmpl = this.templates.find(t => t.templateId === templateId) || {};
            // grab exactly that template's array of privileges
            const privileges = Array.isArray(templatesMap[templateId])
              ? templatesMap[templateId]
              : [];
            return {
              templateId,
              templateName: tmpl.templateName || "",
              // shallow copy to avoid accidental mutation
              privileges: privileges.slice()
            };
          });
          return { roleId, permission };
        }
      );
  
      return {
        studyId: this.studyId,
        rolePrivileges
      };
    },

    async getFormPrivilege(roleId = null) {
      const token = store.getters.getIdToken;
      const params = { studyId: this.studyId };
      if (roleId != null) params.roleId = roleId;
    
      try {
        const { data } = await axios.get(
          `${this.baseurl}/forms/formsprivilege/getprivileges`,
          { headers: { Authorization: `Bearer ${token}` }, params }
        );
    
        this.formPrivilegeItems = data;
        this.addPrivilegebutton = data.length === 0;
    
        // 1) unique template IDs
        const templates = [...new Set(data.map(i => i.templateId))];
        this.selectedTemplateIds = templates;
    
        // 2) unique role IDs
        const roles = [...new Set(data.map(i => i.roleId))];
        this.selectedRoleList = roles;
    
        // 3) build nested map
        const nested = {};
        roles.forEach(rid => {
          nested[rid] = {};
          templates.forEach(tid => {
            // find the specific item for (rid,tid)
            const match = data.find(
              i => i.roleId === rid && i.templateId === tid
            );
            nested[rid][tid] = match
              ? (match.privileges || []).slice()
              : [];
          });
        });
        this.rolesAndPrivilegelist = nested;
        this.temprolesAndPrivilegelist = nested;
    
      } catch (err) {
        console.error("Error fetching privileges:", err);
      }
    },
   
    async updateFormPrivilege() {
        // 1) validation
        if (this.selectedRoleList.length === 0) {
          alert(this.$t("navigations.please select role and privilege"));
          return;
        }
        if (this.selectedTemplateIds.length === 0) {
          alert(this.$t("navigations.no template selected"));
          return;
        }

        
        // await this.readdmissingprivileges();
        // 2) build payload using the same helper
        const payload = this.formatPrivileges(
          this.rolesAndPrivilegelist,
          this.selectedTemplateIds
        );

        // 3) send update
        try {
          await axios.put(
            `${this.baseurl}/forms/formsprivilege/update`,
            payload,
            this.head
          );
          alert(this.$t("navigations.privilege updated successfully"));
        } catch (err) {
          console.error("Error updating privileges", err);
          alert(this.$t("navigations.failed to update privilege"));
        }
      },

      async readdmissingprivileges(){
        Object.entries(this.temprolesAndPrivilegelist).forEach(([roleId, tmplMap]) => {
            if (!this.rolesAndPrivilegelist[roleId]) {
              // whole role was removed—re-add it wholesale
              this.rolesAndPrivilegelist[roleId] = { ...tmplMap };
            } else {
              // role still there, but maybe some template keys are missing
              Object.entries(tmplMap).forEach(([templateId, savedPrivs]) => {
                if (!Array.isArray(this.rolesAndPrivilegelist[roleId][templateId])) {
                  // re-add that template’s old privileges
                  this.rolesAndPrivilegelist[roleId][templateId] = savedPrivs.slice();
                }
              });
            }
          });
          console.log("this.temprolesAndPrivilegelist",this.temprolesAndPrivilegelist);
           console.log("this.rolesAndPrivilegelist",this.rolesAndPrivilegelist);
           console.log("this.selectedTemplateIds",this.selectedTemplateIds);
      },
    uniqueBy(arr, key) {
        const seen = new Set();
        return arr.filter(o => {
          if (seen.has(o[key])) return false;
          seen.add(o[key]);
          return true;
        });
      },
    async templateList() {
      axios.get(`${this.baseurl}/forms/template/listtemplate?IsPrivileged=false&Status=Approved&StudyID=${this.studyId}&pagesize=100&SortProperty=templateName&SortOrder=0`, this.head)
        .then((res) => {
          console.log("template details ", res.data.results);
          this.permissiontemplatlist = res.data.results;
          this.templates = this.uniqueBy(this.permissiontemplatlist,"sourceTemplateId");
        })
        .catch(err => console.log("error in get template list", err));
    },
    async getPagesByTemplateId(id, version) {
      await axios.get(`${this.baseurl}/forms/templatedesign/getpagesbyid?formId=${id}&version=${version}`, this.head)
        .then((res) => {
          console.log("get pages...", res.data);
          this.newtemplate = res.data;
        })
        .catch(err => console.log("error in get pages", err))
    },
    async visitPopup(visitIdEdit) {
      this.showSiteModal = true
      this.visitId = visitIdEdit
    },
    async soAPopup(soAIdEdit) {
      console.log("entered",soAIdEdit)
      this.showSoAModal = true
      this.soAId = soAIdEdit
    },
  
    async deleteForms(id) {
      if (confirm(this.$t('navigations.are you sure you want to delete this form?'))) {
        await axios.delete(
          `${this.baseurl}/forms/templatedesign/deleteform?formId=${id}`, this.head
        )
          .then((res) => {
            alert(this.$t("navigations.form deleted successfully"))
            this.getECRF();
            this.templateList();
          })
          .catch((err) => {
            alert(this.$t("navigations.failed due to internal error"))
            console.error(err);
          });
      }
      this.showSidePopup = [false];
    },
    async deleteVist(id) {
      if (confirm(this.$t('navigations.are you sure you want to delete this visit?'))) {
        await axios.delete(`${this.baseurl}/management/visit/delete?id=${id}`, this.head)
          .then((res) => {
            alert(this.$t("navigations.visit deleted successfully"));
            this.listVisit();
          })
          .catch((err) => {
            alert(this.$t("navigations.failed due to internal error"))
            console.error(err);
          });
      }
      this.showVisitPopup = [false];
    },
    async viewtemplatefun(templateFormId, version) {
      store.dispatch("setViewtemplateid", templateFormId);
      store.dispatch("setViewformid", templateFormId);

      this.$router.push(`/viewform/${templateFormId}`);
    },
    async createNewVersion(templateFormId, version, sourceTemplateId, templateId) {
      console.log(" in create new version study profile", version)
      localStorage.setItem('isStudyProfileRoute', true);
      localStorage.setItem('templateFormId', templateFormId);
      localStorage.setItem('version', version);
      localStorage.setItem('sourceTemplateId', sourceTemplateId);
      localStorage.setItem('latestTempId', templateId)
      localStorage.setItem('DesignFormPrvRoute', "studyProfile");
      this.$router.push({
        path: '/formdesigner',
        query: {
          templateId: templateId
        }
      });
    },
    
    async gettemplatedata() {
      await axios
        .get(`${this.baseurl}/forms/template/listtemplate?IsPrivileged=false&Status=Approved&StudyID=${this.studyId}&SortProperty=templateName&SortOrder=0`, this.head)
        .then((res) => {
          this.templatelist = (res.data.results || []).sort((a, b) =>
            a.templateName.localeCompare(b.templateName)
          );
          console.log("list template data is...", this.templatelist)
        })
        .catch((err) => {
          console.log("error in get template details ", err);
        });
    },
    async assignTemplate() {
      if (this.selectedTemplateIds.length == 0) {
        alert(this.$t('navigations.please select a form'))
      }
      else {
        this.templateNameArray = []
        console.log("Value is", this.selectedmodeltemplate)
        this.selectedmodeltemplate.forEach((item, index) => {
          this.formsArray[index] = {
            "template_ID": "",
            "templateName": "",
            "version": ""
          },
            this.formsArray[index].template_ID = item.templateId
          this.formsArray[index].templateName = item.templateName
          this.formsArray[index].version = item.version
        })
        await axios
          .put(`${this.baseurl}/management/visit/assigntemplate`,
            {
              "visitID": this.selectedvisitid,
              "forms": this.formsArray
            }, this.head
          )
          .then((res) => {
            alert(this.$t('navigations.form assigned successfully'));
            console.log(res.data);
            this.formsArray = [],
              this.selectedmodeltemplate = []
            this.listVisit();
          })
          .catch((err) => {
            console.log("error in assign template", err);
          });
        this.closeTemplateModal();
      }
    },
    async createTemplate() {
      localStorage.setItem('isFormCreateTemplateRoute', true);
      this.$router.push(`/formdesigner`);
      localStorage.setItem('DesignFormPrvRoute', "studyProfile");
    },
    closecreatenewversion() {
      this.newversionformid = "";
      this.creatversionpopup = false;
    },
    async closeModal() {
      this.showSiteModal = false;
      await this.listVisit();
    },
    async closeRetireModal() {
      this.retireFormModal = false;
      await this.getECRF();
      await this.templateList();
      await this.listVisit();
    },
    async closeSoAModal(){
      await this.listSOAs();
      this.showSoAModal = false;
    },
    async openTemplateModal(visitid) {
      this.selectedvisitid = visitid;
      this.showAssignTemplate = true
      await this.gettemplatedata();
      await this.getAllForms(visitid);
      if (this.formItems != null) {
        this.selectedTemplateIds = this.formItems.map(item => item.template_ID);
      }

    },
    async closeTemplateModal() {
      this.selectedTemplateIds = [];
      this.showAssignTemplate = false;
    },
    async openFormsModal(visitid, patientId) {
      console.log("from fill form list", patientId)
      localStorage.setItem("patID", patientId)
      this.selectedvisitid = visitid;
      await this.getAllForms(visitid);
      this.showVisitForms = true;

    },
    async closeModalForms() {
      this.showVisitForms = false;
    },
    async getAllForms(visitId) {
      const idtoken = store.getters.getIdToken;
      await axios
        .get(
          `${this.baseurl}/management/visit/getallforms?studyId=${this.studyId}&visitId=${visitId}`,
          {
            headers: {
              Authorization: "Bearer " + idtoken,
              "Content-Type": "application/json",
            },
          }
        )
        .then((res) => {
          this.formItems = res.data;
          console.log("visit form list is...", this.formItems);
        })
        .catch((err) => {
          console.log(err);
        });
    },
    async onClickButton() {
      this.showLoadingAnimation = true;
      this.clicked = true;
      await this.getStudyDescription();
      this.showLoadingAnimation = false;
      this.clicked = false;
    },
    async getStudyDescription() {

      const studyId = store.getters.getStudyIs;
      try {
        const response = await axios.get(`${this.baseurl}/management/study/getbyid?id=${studyId}`, this.head);

        this.StudyDescription = response.data;
        console.log("StudyDescription", this.StudyDescription);
        await this.formGeneration();

        if (Array.isArray(this.StudyDescription.studyProperties)) {
          this.FromStudy = this.StudyDescription.studyProperties;

        } else {
          console.log("No arrays found in studyProperties");
          this.FromStudy = [];
        }
      } catch (error) {
        console.log("Error in getting study:", error);
      }

    },
    async formGeneration() {
      // this.FromStudy.push(this.values.description)
      axios.get(`${this.baseurl}/forms-ml/mlmodel/getvalues?model_name=${this.values.modelName}&data=${this.StudyDescription}&threshold=${this.values.threshold}`)
        .then((res) => {
          this.formList = res.data;

          console.log("Arrays extracted from studyProperties and stored in FromStudy:", this.FromStudy);
          console.log("Form list", res.data)

          this.$router.push({
            path: '/FormSuggestions',
            query: {
              formList: encodeURIComponent(JSON.stringify(this.formList))
            }
          });
        })
        .catch(err => console.log("error in get study", err));
      await store.dispatch("setformList", JSON.stringify(this.formList))
    },
    async viewForm(id) {
      this.$router.push(`/viewTemplate/studyProfile/${id}`);
    },
    async listSOAs(){
      await axios.get(`${this.baseurl}/management/study/listsoa?studyId=${this.studyId}&activityType=${this.activityType}&pageindex=${this.soaCurrentPage}&pagesize=${this.pageSize}`,  this.head)
        .then((res) => {
          console.log("SoA list", res.data);
          this.SoAList = res.data.entities;
          
          let totalCount = res.data.totalCount;
          this.soaTotalPages = parseInt(totalCount / this.pageSize);
          if (totalCount % this.pageSize != 0) {
            this.soaTotalPages = this.soaTotalPages + 1;
          }
        }).catch(err => {console.log('error in listing SoA', err)})
    },
    async deleteSoA(id, index){
      if (confirm(this.$t("navigations.are you sure you want to delete this activity?"))) {
        await axios.delete(`${this.baseurl}/management/study/deletesoa?id=${id}`, this.head)
        .then((res) => {
              console.log(" SoA deleted", res.data);
          }).catch(err => console.log('error deleting SoA'));
      }
      this.showSoaPopup[index] = false;
      this.listSOAs();
    },
  },
};